;(function () {
  'use strict'
  angular
    .module('contrast.compliance-policy')
    .directive('compliancePolicyWarning', function () {
      return {
        restrict: 'E',
        scope: {
          policies: '=',
          org: '=',
          tooltipPlacement: '@'
        },
        templateUrl:
          'components-org/compliance-policy/compliance-policy-warning.html'
      }
    })
})()
